
import { Component, Vue, Watch } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import SelectProducts from '@/components/orders/new-order/SelectProducts.vue';
import OrderReferenceAndShipping from '@/components/orders/new-order/OrderReferenceAndShipping.vue';
import OrderSummaryAndConfirmation from '@/components/orders/new-order/OrderSummaryAndConfirmation.vue';
import StepsBar from '@/components/StepsBar.vue';
import { ValidationObserver } from 'vee-validate';

@Component({
  components: {
    LayoutDefault,
    SelectProducts,
    OrderReferenceAndShipping,
    OrderSummaryAndConfirmation,
    StepsBar,
    ValidationObserver,
  },
})
export default class NewOrder extends Vue {
  prefetched = false;

  steps: string[] = [
    'select-products',
    'order-reference-and-shipping',
    'order-summary-and-confirmation',
  ];

  get step(): string {
    return this.$store.state.order.orderStep;
  }

  @Watch('$route', { immediate: true })
  onUrlChange() {
    const { step } = this.$route.params;
    this.$store.commit('order/setOrderStep', step);
  }

  beforeCreate() {
    // In Vue this function is called twice in the same
    // lifecycle, so check if the fetches are dispatched
    // already
    if (this.prefetched) {
      return;
    }
    this.prefetched = true;

    // Prefetch data needed by the order steps
    this.$store.dispatch('order/fetchProducts');
    this.$store.dispatch('order/fetchOrders');
    this.$store.dispatch('order/fetchShipToPartners');
  }
}
